// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"PointRecordList--next-sr-only--1skon5F","pageContent":"PointRecordList--pageContent--LH6Z7Zi"};